import * as actionTypes from '../../Action/actionTypes';

export const addFloor =(data)=>{
  return {
    type: actionTypes.ADD_FLOOR,
    value: data
  }
};

export const getFloor =(data)=>{
  return {
    type: actionTypes.GET_FLOOR,
    value: data
  }
};
export const getAllLocations =(data)=>{
  return {
    type: actionTypes.GET_ALL_LOCATIONS,
    value: data
  }
};
